import * as React from 'react';

// Components
import WorkTypeOptions from '../../../../../../../../../../components/WorkTypeOptions';
import TableCellRenderDropdown from '../TableCellRenderDropdown';

export class WorkTypeTableCellRenderDropdown extends React.PureComponent<*> {
    render() {
        return (
            <WorkTypeOptions useCompositeKey>
                {options => (
                    <TableCellRenderDropdown
                        options={options}
                        {...this.props}
                    />
                )}
            </WorkTypeOptions>
        );
    }
}

export default WorkTypeTableCellRenderDropdown;
